.editQuizTitleRow {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;
	flex-wrap: wrap;
	justify-content: center;

	& :global(.MuiTypography-root) {
		color: #212121;
		font-size: 1rem;
		font-weight: 700;
		line-height: 1.4;
		text-align: center;
	}
}

.headerStepper:global(.MuiStepper-root) {
	overflow-y: auto;
	height: 100%;
	border: none;
	padding: 0.5rem;
	box-sizing: border-box;
	scrollbar-gutter: stable;
}

.stepperWrapper {
	background-color: #fbfbfb;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	height: 100%;
	width: 100%;
	border-radius: 20px;
	border: 1px solid #e2e2e2;
	overflow: auto;
	padding: 1.25rem 0.125rem 2rem 0.125rem;
	box-sizing: border-box;
}

.mobileStepButton:global(.MuiButton-root) {
	width: 100%;
	border-radius: 8px;
	padding: 0.5rem;
	background-color: #f4f5fc;
	border: 1px solid #e2e2e2;
	font-size: 0.9375rem;
	line-height: 1.5;
	color: #42296e;
	font-weight: 600;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: #f5f5f5;
	}

	.mobileStepNumber {
		color: #42296e;
		border: 1px solid #9288cb;
		background-color: #d4cfef;
		box-shadow: inset 0 0 0 2px #fff;
		background-color: #d4cfef;
		box-sizing: border-box;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 600;
		font-size: 0.875rem;
		line-height: 0;
	}
}

@media (max-width: 768px) {
	.headerStepper {
		margin: 0px;
		justify-content: unset;
		max-width: unset;
		margin-bottom: 0.625rem;
	}

	.stepperWrapper {
		height: unset;
		padding: 0.5rem !important;
		border: none;
	}
}
